<template>
    <span class="dot" v-b-tooltip.left.hover :title="title"></span>
</template>

<script>
import "./Dot.scss";

export default {
    name: "Dot",
    props: ["title"]
};
</script>